import { render, staticRenderFns } from "./blog-right-sidebar.vue?vue&type=template&id=ddb184fc&"
import script from "./blog-right-sidebar.vue?vue&type=script&lang=js&"
export * from "./blog-right-sidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports